import React, { useState, useRef } from 'react'
import AutoSwiper from '../../../../components/swiper/autowidth'
import Affix from '../../../../components/affix'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { useApp } from '../../../../hooks/common'
import BottomNavigation from '../../../../layout/fragments/bottom-navigation'
import Footer from '../../../../layout/fragments/footer'
import { useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import BlackCouponAlert from '../../../../layout/fragments/black-coupon-alert'



const TopNavigation = props => {
    useStyles(classes)
    const { modules, theme } = props
    const [swiper, setSwiper] = useState()
    const namedModuleRefs = useRef()
    const [selectedModuleId, setSelectedModuleId] = useState()
    const clicking = useRef()

    useEffect(() => {
        namedModuleRefs.current = modules.map(m => document.getElementById(m.id))?.filter(m => !!m)
        setSelectedModuleId(modules?.[0]?.id)

        if (swiper) {
            if (window.IntersectionObserver) {
                window.simpleLandingObserver = new IntersectionObserver(entries => {

                    const currentEntry = entries?.[entries?.length - 1]

                    if (currentEntry) {
                        if (currentEntry.isIntersecting) {
                            setSelectedModuleId(currentEntry.target.id)
                            const index = namedModuleRefs.current?.findIndex(r => r.id === currentEntry.target.id)
                            if (!clicking.current) {
                                swiper.slideTo(index)
                            }
                        }
                    }


                }, { threshold: [0.5] })


                namedModuleRefs.current?.forEach(namedModule => {
                    window.simpleLandingObserver.observe(namedModule)
                })
            }
        }




        return () => {
            window.simpleLandingObserver?.disconnect?.()
        }



    }, [modules, swiper])


    const clickHandle = (s, e) => {
        if (s.clickedIndex === s.activeIndex || s.clickedIndex === s.activeIndex + 1) {
            s.slidePrev(300)
        } else {
            s.slideNext(300)
        }
    }


    const scrollToModule = m => {
        clicking.current = true
        const currentRef = namedModuleRefs.current?.find?.(md => md.id === m.id)
        currentRef?.scrollIntoView?.({
            behavior: 'smooth',
            block: 'center'
        })
        setSelectedModuleId(m.id)

        setTimeout(() => {
            clicking.current = false
        }, 1000)
    }

    return <AutoSwiper options={{
        slidesPerView: 'auto',
        onSwiper: setSwiper,
        watchSlidesVisibility: true,
        slideVisibleClass: 'swiper-visible',
        onClick: clickHandle
    }} className={classes.TopNavigation} items={modules} render={(item, index) => {
        return <span className={`${classes.Navigation} ${selectedModuleId === item.id ? classes.Active : ''}`} style={{
            color: selectedModuleId === item.id ? theme?.activeTextColor : theme?.textColor,
            backgroundColor: selectedModuleId === item.id ? theme?.activeBackgroundColor : theme?.backgroundColor
        }} onClick={e => scrollToModule(item)}>{item.name}</span>
    }} />
}

export default props => {
    const { modules, theme } = props
    const [showTopNav, setShowTopNav] = useState(false)
    const isApp = useApp()
    const location = useLocation()
    const scrollRef = useRef(null)

    const sortedModules = modules?.sort((m1, m2) => m1.sort - m2.sort)?.map((m, i) => ({ ...m, index: i }))
    const navs = sortedModules?.filter(s => !!s.name)


    scrollRef.current = e => {
        const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
        setShowTopNav(() => {
            return scrollTop >= 50
        })
    }

    useEffect(() => {
        window.addEventListener('scroll', scrollRef.current)
        return () => {
            window.removeEventListener('scroll', scrollRef.current)
        }
    }, [])


    return <div className={classes.Container}>

        {
            showTopNav && navs?.length > 4 && <Affix offsetTop={isApp ? 0 : 44}>
                <TopNavigation theme={theme?.topNav} modules={navs} />
            </Affix>
        }



        {
            theme?.backgroundImage && <section className={classes.Back}>
                <img src={theme?.backgroundImage} />
            </section>
        }


        <div className={classes.Body} style={{
            backgroundColor: theme?.backgroundColor,
        }}>
            {
                props.children
            }
        </div>

        {
            (location.pathname.endsWith('/i/new') || location.pathname.endsWith('/landing-page/new')) && <BottomNavigation />
        }

        {
            !isApp && <React.Fragment>
                <Footer />
                <BlackCouponAlert />
            </React.Fragment>
        }

        
    </div>
}